import styled from 'styled-components';

export const InputWrapper = styled.div`
  border: 1px solid #e2e8f0;
  width: 100%;
  border-radius: 14px;
  background-color: #ffffff;
  display: flex;
  gap: 15px;
  padding: 15px;
  align-items: center;

  > div {
    min-height: 0;
  }

  .input {
    color: #6c757d !important;
  }
`;

export const TableContainer = styled.div`
  margin-top: 15px;
  border-radius: 14px;
`;

export const ChatWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;

export const BackPermissions = styled.div`
  display: flex;
  margin-left: 14px;
  margin-top: 15px;
`;

export const BackMainMessage = styled.div`
  flex-direction: column;
  padding-top: 10px;
`;

export const BackMessage = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #6c757d;
`;

export const BackMessage2 = styled.p`
  font-size: 18px;
  color: #212529;
  display: flex;
  font-weight: 500;
`;

export const TabButton1 = styled.button`
  border-radius: 8px;
  border: none;
  background: ${({ $isActive }) => ($isActive ? '#2D6CDF' : '#f8f9fa')};
  color: ${({ $isActive }) => ($isActive ? '#fff' : '#6c757d')};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
`;

export const BackToListBtn = styled.button`
  border-radius: 10px;
  border: 0.4px solid #d4d8dd;
  background: #fff;
  width: 100px;
  height: 40px;
  color: #1d3557;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }
`;

export const ConfigureButton = styled.button`
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #ccc;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 113px;
  height: 32px;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  border-radius: 20px;
  border: ${({ isActive }) => (isActive ? '1px solid #15C7A7' : 'none')};
  background: ${({ isActive }) => (isActive ? '#FFFFFF' : '#F8FAFC')};
  width: fit-content;

  p {
    color: ${({ isActive }) => (isActive ? '#15C7A7' : '#62748E')};
    margin: 0;
  }
`;
